var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loadingApp position-relative",style:({ minHeight: _vm.loaderHeight })},[_c('div',{staticClass:"imgContainer"},[_c('img',{attrs:{"src":_vm.loaderSrc,"alt":""}})])]):_c('div',{staticClass:"dashboard-tile"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }